import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/**
 * Created by tonicli on 2017/3/21.
 */
var assign = require('lodash/assign');
var GLOBAL_CACHE_KEY = '__global_cache_key__';
var _defaultCacheOptions = {
    cacheKey: '__cacheKey',
    maxAge: 60000
  },
  F = function F() {},
  _create = Object.create || function (prototype) {
    F.prototype = prototype;
    return new F();
  };
export default function (cacheOptions) {
  var _cacheOptions = assign(_create(_defaultCacheOptions), cacheOptions || {});
  var _cachePool = {};
  function getCacheKey(options) {
    var cacheKey = _cacheOptions.cacheKey;
    if (typeof cacheKey == 'string' && options && options.data) {
      return options.data[cacheKey];
    }
    if (typeof cacheKey == 'function') {
      return cacheKey(options);
    }
    return GLOBAL_CACHE_KEY;
  }
  function isExpire(cacheKey) {
    var cache = _cachePool[cacheKey];
    return !cache || Date.now() > cache.reqTime + _cacheOptions.maxAge;
  }
  function cache(cacheKey, data) {
    _cachePool[cacheKey] = {
      reqTime: Date.now(),
      data: data
    };
  }
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
      var cacheKey;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cacheKey = this.getCacheKey(this.request.options);
              if (cacheKey) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return next();
            case 4:
              _context.next = 13;
              break;
            case 6:
              if (isExpire(cacheKey)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", _cachePool[cacheKey].data);
            case 10:
              _context.next = 12;
              return next();
            case 12:
              cache(cacheKey, this.response);
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}